export default __webpack_public_path__ + "static/media/r_wdt_c_3_4.31bde1ee.mp3";